import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    form: {
        nome: "",
        label: "",
        fatorSi: 1,
        unidadeBaseSi:"",
    },
    cachedUnidades:[]

}


const unidadeReducer = createSlice({
    name: 'unidadeReducer',
    initialState,
    reducers: {
        setNomeUnidade(state, action) {
            state.form.nome = action.payload
        },
        setLabelUnidade(state, action) {
            state.form.label = action.payload
        },
        setFatorSi(state, action) {
            state.form.fatorSi = action.payload
        },
        setUnidadeBaseSi(state, action) {
            state.form.unidadeBaseSi = action.payload
        },
        populateToEdit(state, action) {
            state.form = action.payload
        },
        setCachedUnidades(state, action){
            state.cachedUnidades = action.payload
        },
        clear(state, action) {
            state.form = initialState.form
        },

    },
})

export const { setNomeUnidade, setLabelUnidade, populateToEdit, clear : clearUnidadeForm, setCachedUnidades, setFatorSi, setUnidadeBaseSi } = unidadeReducer.actions
export default unidadeReducer.reducer